import { deepCamelCase } from '../../utils/transforms';
import { HTTP_RESPONSE_CODE } from '../common/consts';

export const responseInterceptor = response => {
    if (response.status === HTTP_RESPONSE_CODE.NO_CONTENT) {
        return [];
    }

    return deepCamelCase(response.data);
};
